import { Link } from 'react-router-dom';
import { MonitorPlay, MapPin, Clock, Mail, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer id="kontakt" data-testid="footer" className="border-t border-[#282C37] bg-[#0B0C0E] py-20">
      <div className="wrap">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#FF6B00]"><MonitorPlay className="h-5 w-5 text-white" /></span>
              <span className="font-display text-lg font-extrabold tracking-tight">GLOBUS Markthalle Koblenz</span>
            </div>
            <p className="eyebrow mt-2">Instore Media</p>
            <p className="t-body mt-5 max-w-md">Bildschirmwerbung im Kaufmoment. Für Partner aus der Region und Marken im Regal.</p>
            <p className="t-muted mt-5 max-w-md">Alle Preise netto zuzüglich 19 % Umsatzsteuer. Sichtkontakte sind eine Modellrechnung auf Basis der Einkäufe an unseren Kassen.</p>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-mono-num text-xs uppercase tracking-[0.25em] text-white">Ihr Kontakt</h3>
            <ul className="mt-5 space-y-4 text-base text-[#B6BCC8]" data-testid="footer-contact">
              <li className="flex items-start gap-3">
                <Phone className="mt-1 h-4 w-4 shrink-0 text-[#FF6B00]" />
                <span className="space-y-1">
                  <span className="font-semibold text-white" data-testid="footer-contact-name">Patrick Schlüter</span>
                  <br />
                  <a href="tel:+4915155778363" data-testid="footer-phone" className="transition-colors hover:text-white">0151 5577 8363</a>
                  <br />
                  <a href="https://wa.me/4915155778363" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="block transition-colors hover:text-white">
                    WhatsApp<br />0151 5577 8363
                  </a>
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-[#FF6B00]" />
                <a href="mailto:p.schlueter@globus.net" data-testid="footer-email" className="transition-colors hover:text-white">p.schlueter@globus.net</a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-mono-num text-xs uppercase tracking-[0.25em] text-white">Markt</h3>
            <ul className="mt-5 space-y-4 text-base text-[#B6BCC8]" data-testid="footer-market">
              <li className="flex items-start gap-3">
                <MapPin className="mt-1 h-4 w-4 shrink-0 text-[#FF6B00]" />
                <span>
                  GLOBUS Markthalle Koblenz-Bubenheim<br />
                  <span data-testid="footer-street">Jakob-Caspers-Str. 2</span><br />
                  56070 Koblenz
                </span>
              </li>
              <li className="flex items-center gap-3"><Clock className="h-4 w-4 shrink-0 text-[#FF6B00]" /> Montag bis Samstag, 8 bis 21 Uhr</li>
            </ul>
          </div>
        </div>


        <div className="mt-14 flex flex-col gap-3 border-t border-[#282C37] pt-6 text-sm text-[#7D8391] sm:flex-row sm:items-center sm:justify-between">
          <p>
            Betreiber: GLOBUS Markthalle Koblenz-Bubenheim · Verantwortlich: Patrick Schlüter
          </p>
          <p className="flex items-center gap-4">
            <span>Auftragsbedingungen Instore Media, Stand September 2026.</span>
            <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-white">Intern</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
